import { Box, styled } from "@mui/material";

export const StyledBoxForPanelLeft = styled(Box)({
	display: "flex",
	justifyContent: "space-between",
});
